<template>
  <div>
    <v-container fluid class="py-0">
      <v-row >
        <v-card flat color="transparent" class="mx-auto py-6 text-center">
          <v-card-title class="display-1 mb-2">{{ $t("service.title") }}</v-card-title>
          <v-card-subtitle class="subtitle-1">SERVICE</v-card-subtitle>
        </v-card>
      </v-row>
      <v-row no-gutters class="text-center" align="start">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-col>
          <v-card :class='"mb-4"+(isMobile?"px-6":"")' flat tile color="transparent">
            <v-card-title :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap"' v-html="$t('service.innerContent')">{{ $t('service.innerContent') }}</v-card-title>
          </v-card>
        </v-col>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>

      <!--平板 -->
      <v-row class="d-none d-sm-flex d-md-none" no-gutters v-for="(item,index) in $t('service.services')" :key="item.title">
        <v-col v-if="(index+1)%2||isMobile">
          <v-hover v-slot:default="{ hover }" origin="center center">
            <v-img :aspect-ratio="16/9" width=370 :src='"../assets/service/s"+(index+1)+".jpg"'>
              <v-scale-transition origin="center center">
              <v-row align="center" class="white--text fill-height text-center" v-if="hover" >
                <v-spacer></v-spacer>
                <v-col>
                  <v-card flat tile color="transparent" >
                    <v-row justify="center">
                    <v-card-title class="white--text title text-center" style="white-space:nowrap;">
                      {{ item.picTitle }}
                    </v-card-title>
                    </v-row> 
                    <v-divider color="white"></v-divider>
                    <v-card-text class="white--text" style="white-space:nowrap;">
                      {{ item.englishTitle }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-spacer class="d-none d-sm-flex"></v-spacer>
              </v-row>
              </v-scale-transition>
             </v-img>
          </v-hover>
        </v-col>
        <v-col class="ml-0">
          <v-card :class='$i18n.locale=="zh"?"py-4 ml-0 pl-2":"py-0 ml-0 pl-2"' width=370 flat>
            <v-card-title class="py-0 my-0">{{ item.title }}</v-card-title>
            <v-card-text>{{ item.content }}</v-card-text>
            <v-card-actions>
              <v-row :justify='isMobile?"center":"start"'>
                <v-btn outlined color="grey" :class='isMobile?"mb-4":"ml-4"' :to="item.link">{{ $t('service.detailBtn') }}</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col v-if="(index+1)%2==0&&!isMobile">
          <v-hover v-slot:default="{ hover }" origin="center center">
            <v-img :aspect-ratio="16/9" width=370 :src='"../assets/service/s"+(index+1)+".jpg"'>
            <v-scale-transition origin="center center">
              <v-row align="center" class="white--text fill-height text-center" v-if="hover">
                <v-spacer></v-spacer>
                <v-col>
                  <v-card flat tile color="transparent" >
                    <v-row justify="center">
                    <v-card-title class="white--text title text-center" style="white-space:nowrap;">
                      {{ item.picTitle }}
                    </v-card-title>
                    </v-row> 
                    <v-divider color="white"></v-divider>
                    <v-card-text class="white--text" style="white-space:nowrap;">
                      {{ item.englishTitle }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
              </v-scale-transition>
             </v-img>
          </v-hover>
        </v-col>
      </v-row>

    <!--非平板 -->
    <v-row class="d-sm-none d-md-flex"  no-gutters v-for="(item,index) in $t('service.services')" :key="item.title">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-col v-if="(index+1)%2||isMobile">
          <v-hover v-slot:default="{ hover }" origin="center center">
            <v-img :aspect-ratio="16/9" width=400 :src='"../assets/service/s"+(index+1)+".jpg"'>
              <v-scale-transition origin="center center">
              <v-row align="center" class="white--text fill-height text-center" v-if="hover" >
                <v-spacer></v-spacer>
                <v-col>
                  <v-card flat tile color="transparent" >
                    <v-row justify="center">
                    <v-card-title class="white--text title text-center" style="white-space:nowrap;">
                      {{ item.picTitle }}
                    </v-card-title>
                    </v-row> 
                    <v-divider color="white"></v-divider>
                    <v-card-text class="white--text" style="white-space:nowrap;">
                      {{ item.englishTitle }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-spacer class="d-none d-sm-flex"></v-spacer>
              </v-row>
              </v-scale-transition>
             </v-img>
          </v-hover>
        </v-col>
        <v-col class="ml-0">
          <v-card :class='$i18n.locale=="zh"?"py-4 ml-0 pl-2":"py-0 ml-0 pl-2"' width=400 flat>
            <v-card-title class="py-0 my-0">{{ item.title }}</v-card-title>
            <v-card-text>{{ item.content }}</v-card-text>
            <v-card-actions>
              <v-row :justify='isMobile?"center":"start"'>
                <v-btn outlined color="grey" :class='isMobile?"mb-4":"ml-4"' :to="item.link">{{ $t('service.detailBtn') }}</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col v-if="(index+1)%2==0&&!isMobile">
          <v-hover v-slot:default="{ hover }" origin="center center">
            <v-img :aspect-ratio="16/9" width=400 :src='"../assets/service/s"+(index+1)+".jpg"'>
            <v-scale-transition origin="center center">
              <v-row align="center" class="white--text fill-height text-center" v-if="hover">
                <v-spacer></v-spacer>
                <v-col>
                  <v-card flat tile color="transparent" >
                    <v-row justify="center">
                    <v-card-title class="white--text title text-center" style="white-space:nowrap;">
                      {{ item.picTitle }}
                    </v-card-title>
                    </v-row> 
                    <v-divider color="white"></v-divider>
                    <v-card-text class="white--text" style="white-space:nowrap;">
                      {{ item.englishTitle }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
              </v-scale-transition>
             </v-img>
          </v-hover>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <v-row class="grey lighten-2 mt-10">
        <v-card flat color="transparent" class="mx-auto py-12 text-center">
          <v-card-title class="display-1 mb-2">{{ $t("service.feature.title") }}</v-card-title>
          <v-card-subtitle class="subtitle-1">KEY FEATURES</v-card-subtitle>
        </v-card>
      </v-row>
      <v-row class="grey lighten-2 pb-4" v-for="(item,index) in $t('service.feature.infos')" :key="item.title">
        <v-spacer class="d-sm-none d-md-flex"></v-spacer>
        <v-col :cols='isMobile?12:"false"'>
          <v-img :aspect-ratio="18/12" :src='"../assets/service/f"+(index+1)+".jpg"'></v-img>
        </v-col>
        <v-col :cols='isMobile?12:"false"' :class='isMobile?"":"ml-2"'>
          <v-card color="transparent" class="ml-0" flat>
            <v-card-title>{{ item.title }}</v-card-title>
            <v-card-text>{{ item.content }}</v-card-text>
          </v-card>
        </v-col>
        <v-spacer class="d-sm-none d-md-flex"></v-spacer>
      </v-row>
    </v-container>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "CompanyService",
  data: () => ({
    isMobile:false
  }),
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  },
  components: {
    "tci-contact-footer": TciContactFooter
  }
};
</script>
<style scoped>
.v-btn:hover:before {
  opacity: 0.5 !important;
}
</style>